import { fetchMemberVips } from '@/api/fetchMemberVips'
import { QUERY_KEY } from '@/constants/queryKey'
import { useQuery } from 'react-query'

const useMemberVips = ({ memberInfoId, enabled = true }: { memberInfoId: string; enabled?: boolean }) => {
  const props = useQuery([QUERY_KEY.FETCH_MEMBER_VIPS, { memberInfoId }], () => fetchMemberVips({ memberInfoId }), {
    enabled: !!memberInfoId && !!enabled,
  })

  return { ...props }
}

export default useMemberVips
